import * as React from "react"
import * as ReactDom from "react-dom"
import Blog from "../components/views/Blog";
import { requestPageData } from "../services/api";
import { checkLang, setCurrentPage } from "../services/general";

export const page = async () => {
	const blogContainer = document.getElementById('blog')
	const BLOGINFO = window.drupalSettings.react.node || await requestPageData({ content: "blog", nid: blogContainer.dataset.nid, langcode: checkLang() })
	ReactDom.render(<Blog data={BLOGINFO} />, blogContainer)
	setCurrentPage('')
}